import React from 'react';
import NuborrowLogo from '../NuborrowLogo/NuborrowLogo';
import menu_icon from '../../assets/menu_icon.svg';
import call_icon from '../../assets/call_icon.svg';
import { navigate } from 'gatsby';

interface SideMenuProps {
  setIsOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
}

function SideMenu({ setIsOpenMenu }: SideMenuProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 z-10 h-screen w-screen overscroll-none bg-white">
      <div className="m-10 flex items-center justify-between">
        <NuborrowLogo className="h-5 w-auto md:h-8 lg:h-5" />
        <div onClick={() => setIsOpenMenu(false)}>
          <img src={menu_icon} alt="menu" />
        </div>
      </div>

      <div className="flex flex-col items-center gap-5 text-lg text-black">
        <div className="cursor-pointer  hover:text-brand lg:block" onClick={() => navigate('/buy')}>
          Buy
        </div>
        <div
          className="cursor-pointer hover:text-brand lg:block"
          onClick={() => navigate('/refinance')}
        >
          Refinance
        </div>
        <div
          className="cursor-pointer hover:text-brand lg:block"
          onClick={() => navigate('/home-equity-loan')}
        >
          Home Equity Loan
        </div>
        <div
          className="cursor-pointer hover:text-brand lg:block"
          onClick={() => navigate('/home-equity-line')}
        >
          Home Equity Line
        </div>
        {/* </div>

      <div className="flex flex-col items-center"> */}
        <div className="flex items-center  font-medium text-brand">
          <img src={call_icon} alt="callIcon" />
          <a href="tel:1 888 372 5588">
            <span className="ml-3 mr-1 mt-1">1</span>888 <span className="ml-1 mt-1">372 55</span>
            88
          </a>
        </div>
        <button
          className="mt-10 w-52 rounded-full bg-brand py-2  font-medium text-white hover:border-2 hover:border-brand hover:bg-white hover:text-brand"
          onClick={() => (window.location.href = 'http://apply.nuborrow.com/')}
        >
          Apply Now
        </button>
      </div>
    </div>
  );
}

export default SideMenu;
